(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-demand-sample"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const cartToken = localStorage.getItem('cartToken');
    const cartMark = localStorage.getItem('cartMark');
    const cartDrawer = document.querySelector('cart-drawer');
    const cartNum = document.querySelectorAll('.cart-count-bubble span');
    const cartNumItem = cartNum[0];
    const cartNumTotal = cartNum[1];
    const addBtn = document.querySelector('#product-add-btn');

    if (!cartDrawer || !addBtn) {
      console.error('DOM elements not found');
      return;
    }

    if (cartToken && cartMark) {
      localStorage.removeItem('cartMark');
      cartDrawer.classList.add('animate', 'active');
    }

    addBtn.addEventListener('click', function() {
      const productId = this.getAttribute('data-id');
      const productData = {
        items: [
          {
            id: productId,
            quantity: 1
          }
        ]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(productData)
      }).then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      }).then((data) => {
        if (document.querySelector('.drawer__inner-empty')) {
          location.reload();
          localStorage.setItem('cartMark', true);
        } else {
          handleCartDrawer(data);
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'add-product',
            cartData: data
          });
          setInterval(() => {
            handleCartNum()
          }, 1000);
        }
      }).catch((error) => {
        console.error('Error adding product to cart:', error);
        alert('Failed to add product to cart. Please try again later.');
      });
    });

    function handleCartDrawer(data) {
      if (cartDrawer) {
        cartDrawer.open();
      }
    }

    function handleCartNum() {
      let cartNumText = Number(cartNumItem.innerText);
      let cartNumber = 0;
      const cartQuantityInput = document.querySelectorAll('.cart-items .quantity__input');
      if (cartNumText < 99) {
        cartQuantityInput.forEach((item) => {
          cartNumber += Number(item.getAttribute('data-cart-quantity'));
        });
        cartNumItem.innerText = cartNumber;
        cartNumTotal.innerText = `${cartNumber} items`;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-download"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const title = document.querySelectorAll('.downloads-tabs-title');
    const tabs = document.querySelectorAll('.downloads-tabs-content');

    title.forEach((item, index) => {
      item.addEventListener('click', () => {
        title.forEach(tab => tab.classList.remove('tabs-title-active'));
        tabs.forEach(tab => tab.classList.remove('downloads-tabs-active'));

        item.classList.add('tabs-title-active');
        tabs[index].classList.add('downloads-tabs-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-section-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const typewriterText = document.querySelector('#banner-content').getAttribute('data-text');
    const typewriterElement = document.querySelector('.typewriter');
    const bannerHeader = document.getElementsByClassName('section-banner-header')[0];

    let typeLength = typewriterText.length;
    let index = 1;
    function typeWriter() {
      if (index < typewriterText.length) {
        typewriterElement.textContent += typewriterText.charAt(index);
        index++;
        if (index === typeLength) {
          bannerHeader.classList.add('bg_color');
          setTimeout(() => {
            typewriterElement.textContent = typewriterText.slice(0,1);
            index = 1;
            bannerHeader.classList.remove('bg_color');
            setTimeout(typeWriter, 150);
          }, 5000);
        } else {
          setTimeout(typeWriter, 150); // 调整打字速度
        }
      }
    }

    typeWriter();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const collectionAll = document.querySelector('.collection-list');
    const collectionItem = document.querySelectorAll('.collection-list__item');
    let allItem = [];

    collectionItem.forEach((item, index) => {
      const indexs = item.getAttribute('data-index');
      allItem[indexs] = item;
    });
    collectionAll.innerHTML = '';
    allItem.forEach(item => {
      if (item) {
        collectionAll.appendChild(item);
      }
    });
     collectionAll.classList.add('collection-list-active');
  });

  } catch(e) { console.error(e); }
})();
})();
